var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checkIfVisible())?_c('router-link',{attrs:{"to":{ name: _vm.route, params: _vm.params, query: _vm.query },"tag":"a"}},[_vm._v("\n    "+_vm._s(_vm.$t(_vm.title))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }